import {useSchemaListThesaurusIds} from 'schema';
import {useAgentSchemas} from 'schemas';

export const useAgentsThesaurusIds = () => {
  const agentSchemas = useAgentSchemas();

  return useSchemaListThesaurusIds(agentSchemas);
};
